<template>
    <v-container>
        <div class="custom_lesson-info mb-10">
            <v-toolbar flat>
                <v-card-actions>
                    <v-icon 
                        @click="$router.go(-1)" 
                        color="secondary"  
                        style="margin-right: 10px"
                    >
                        mdi-arrow-left-thick
                    </v-icon>
                </v-card-actions>
                <v-toolbar-title style=""><b>Lesson {{lesson.lessonId}}</b></v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar> 

            <v-card class="mt-4 custom_v-card">
                <v-divider></v-divider>
                <v-row no-gutters class="mt-4">
                    <v-col cols="2" align="right" class="mr-3">
                        <v-card-text class="pr-5"> Title </v-card-text>
                    </v-col>
                    <v-col cols="6">
                        <div class="pdngtb"><b>{{ lesson.lessonTitle }}</b></div>
                    </v-col>
                </v-row>

                <v-row no-gutters >
                    <v-col cols="2" align="right" class="mr-3">
                        <v-card-text class="pr-5"> Description </v-card-text>
                    </v-col>
                    <v-col cols="6">
                        <div class="pdngtb"><b>{{ lesson.lessonDescription }}</b></div>
                    </v-col>
                </v-row>
                <v-row no-gutters >
                    <v-col cols="2" align="right" class="mr-3">
                        <v-card-text class="pr-5">Introduction</v-card-text>
                    </v-col>
                    <v-col cols="6">
                        <div class="pdngtb">
                            <b>{{ lesson.lessonIntroduction }}</b>
                        </div>
                    </v-col>
                </v-row>

                <v-row no-gutters >
                    <v-col cols="2" align="right" class="mr-3">
                        <v-card-text class="pr-5">Instruction</v-card-text>
                    </v-col>
                    <v-col cols="6">
                        <div class="pdngtb"><b>{{ lesson.lessonInstruction }}</b></div>
                    </v-col>
                </v-row>

                <v-row no-gutters class="mt-4">
                    <v-col cols="4" align="left" class="ml-10">
                        <v-card-text class="pr-5"><b>Statement and Key Sequence</b></v-card-text>
                    </v-col>
                </v-row>
                <v-row class="ml-10">
                    <v-data-table
                        dense
                        fixed-header
                        :headers="headersLessonStatementKeySequence" 
                        bold
                        :items="lesson.lessonStatementKeySequenceArray"
                        :items-per-page="10"
                        sort-by="['serialNum', 'lessonStatement', 'lessonKeySequence']"
                        bordered 
                    >
                        <template v-slot:item.serialNum="{item}">
                            {{lesson.lessonStatementKeySequenceArray.indexOf(item)+1}} 
                        </template>
                    </v-data-table>
                </v-row>

                <v-row no-gutters >
                    <v-col cols="2" align="right" class="mr-3">
                        <v-card-text class="pr-5">Lesson Status</v-card-text>
                            </v-col>
                            <v-col cols="6">
                                <v-switch
                                    v-model="lesson.lessonStatus"
                                    inset
                                    dense
                                    class="mt-2" 
                                    color="blue"
                                    disabled
                                    :label="lesson.lessonStatus ? 'Active' : 'Inactive'"
                                >
                                </v-switch>
                            </v-col>
                </v-row>
            </v-card>

            <v-toolbar flat>
                <v-toolbar-title style="color:#223F7D" class="pa-2"><b>Questions</b></v-toolbar-title>
                </v-toolbar>
                <v-card class="pa-2 custom-bg_orders">
                    <v-row class="pa-2" no-gutters>
                        <v-spacer></v-spacer>
                        <div class="mr-3" v-if="!noData">
                            Search:
                        </div>
                        <v-col cols="12" sm="6" md="2">
                            <v-text-field
                                prepend="search"
                                v-if="!noData"
                                type="text"
                                dense
                                v-model="search"
                                single-line
                                hide-details
                                outlined
                                no-gutters
                                height="32"
                                style="font-size: 14px"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-data-table
                        class="ma-2 custom-admin-table"
                        outlined
                        dense
                        fixed-header
                        :headers="headers"
                        :items="questionList"
                        :items-per-page="10"
                        sort-by="['serialNum', 'questionStatement','questionStatus']"
                        :hide-default-footer="noData"
                        :search="search"
                        :hide-default-header="noData"
                        no-data-text="No Data Available"
                        no-result-text="No Data Found"
                        bordered
                    >

                        <template v-slot:item.serialNum="{item}">
                            {{questionList.indexOf(item)+1}} 
                        </template>
                        <template v-slot:item.questionStatus="{item}">
                            <v-switch
                                v-model="item.questionStatus"
                                class="mt-0 mr-1" 
                                color="blue"
                                inset
                                dense
                                disabled
                                :label="item.questionStatus?'Active':'Inactive'"
                            >
                            <!-- @change="saveQuestionStatus(item._id, item.questionStatus)" -->
                            </v-switch>
                        </template>
                        <template v-slot:item.viewDetail ="{item}"> 
                            <router-link 
                                :to="'/admin/questioninfo/'+item._id+'/'+item.questionType" 
                                style="text-decoration:none;">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{on}">
                                        <v-icon
                                            class="mr-2"
                                            color="blue darken-3"
                                            v-on="on"
                                        >mdi-eye
                                        </v-icon> 
                                    </template>
                                    <span>View Details</span>
                                </v-tooltip>
                            </router-link>
                        </template>
                    </v-data-table>    
                </v-card>
            </div>
        </v-container>
</template>

<script>
import Lesson from "../../models/Lesson";
import LessonQuestionMapping from "../../models/LessonQuestionMapping";
import url1 from '../../../config.js';

export default {
     beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id) 
                  {
                      vm.$router.push("/");
                  }
                  
            }, 0);
        });
    },

    name: "LessonInfo",
    props:['lesson_id' ],
    data() {
        return {
            search:'',
            noData:false,
            url:`${url1.url}`,
            questionList:[], 
            lesson:new Lesson(),
            headers:
            [
            {text:'S.No', value:'serialNum'},
            {text:'Id', value:'questionId'},
            {text:'QuestionType', value:'questionType'},
           // {text:'Title', value:'questionTitle'},
            {text:'Statement', value:'questionStatement'},
            {text:'Status', value:'questionStatus'},
            {text:'', value:'viewDetail'},
            ],
            headersLessonStatementKeySequence:[
                    {text: 'S. No.', value: 'serialNum' },
                    {text:"Statement", value:"lessonStatement"},
                    {text:"Key Sequence", value:"lessonKeySequence"},
                ],
            }
    },

    methods:{

        getLesson() {
            Lesson.getLessonInfo(this.lesson_id, this.auth.token).then((res)=>{
                console.log('Getlesson Client res.data client', res.data);
                this.lesson=res.data;
               // this.lessonImg=`${this.url}/uploads/`+res.data[0].lessonImage;
               // this.lessonAud=`${this.url}/uploads/`+res.data[0].lessonAudio;
                console.log('Get lesson, this.lesson', this.lesson);
            }).catch(err=>{
                console.log('error occured', err);
            })
        },

        getQuestions(){
            LessonQuestionMapping.getExistingQuestionsOfALesson(this.lesson_id, this.auth.token)
                .then(res=>{
                    console.log('questions', res.data);
                    this.questionList=res.data;
                }).catch(err => console.error(err.response.data));
        }, 
    },

    computed: {
        auth() {
            return this.$store.state.auth;
        }
    },
    mounted() {
        this.getLesson();
        this.getQuestions();
    }
}
</script>
<style scoped>
.custom_lesson-info >>> header {
    background: transparent !important;
}
.custom_v-card {
    border-top: 3px solid #1b73ba;
}
.v-card__title {
    font-size: 18px;
}
.v-card__actions {
    padding: 4px 8px;
}
.custom_lesson-info >>> .v-card__text {
    padding: 10px 16px;
}
.custom_lesson-info >>> .v-badge__badge.blue {
    height: 30px;
    min-width: 30px;
    border-radius: 50px;
}
.custom_lesson-info >>> .mdi-pencil-outline::before {
    font-size: 16px;
}
.custom_lesson-info >>> .v-input__append-outer,
.custom_lesson-info >>> .v-input__prepend-outer {
    margin-top: 9px;
}
.pdngtb {
    padding: 10px;
}
table.v-data-table thead th {
      font-size: 20px !important;

 }
</style>